import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import type { VesselRequest } from '@routes/sidebar/admin-center/___shared___/dashboards/api/vessel.api.ts';
import { getApiVessel } from '@routes/sidebar/admin-center/___shared___/dashboards/api/vessel.api.ts';
import { VESSEL_INITIAL_STATE } from '@routes/sidebar/admin-center/___shared___/dashboards/model/constants.ts';
import type { VesselStatistic as VesselResponse } from '@routes/sidebar/admin-center/___shared___/dashboards/types.ts';
import { extractError } from '@utils/slice.ts';

interface VesselError {
    message?: string;
    [k: string]: any;
}

interface VesselState {
    error: VesselError | null;
    vessel: VesselResponse;
    isGetVesselPending: boolean;
}

const initialState: VesselState = {
    error: null,
    vessel: VESSEL_INITIAL_STATE,
    isGetVesselPending: false,
};

export const getVessel = createAsyncThunk<
    VesselResponse,
    { tenantAlias: string; vesselId: number; payload: VesselRequest },
    { rejectValue: VesselError }
>('adminCenterDashboardVessel/getVessel', ({ tenantAlias, vesselId, payload }, { rejectWithValue }) =>
    getApiVessel({ tenantAlias, vesselId, payload }).catch((err) => rejectWithValue(err)),
);

const adminCenterDashboardVesselSlice = createSlice({
    name: 'adminCenterDashboardVessel',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder.addCase(getVessel.pending, (state) => {
            state.isGetVesselPending = true;
            state.error = null;
        });

        builder.addCase(getVessel.fulfilled, (state, action) => {
            state.isGetVesselPending = false;
            state.vessel = action.payload;
        });

        builder.addCase(getVessel.rejected, (state, action) => {
            state.isGetVesselPending = false;
            state.error = extractError(action);
        });
    },
});

export default adminCenterDashboardVesselSlice.reducer;
